import React,{useState,useEffect,useMemo,useCallback} from "react";
import {useHistory} from 'react-router-dom';

///Styles
import { Container } from "./styles";

///Components
import { Header } from "../../components/pagesComponents/oldCompaniesPage/Header";
import { Input } from "../../components/pagesComponents/oldCompaniesPage/Input";
import { Table } from "../../components/pagesComponents/oldCompaniesPage/Table";
import { Modal } from "../../components/pagesComponents/oldCompaniesPage/Modal";

///Services
import { api } from "../../services/api";
import { download_csv } from "../../components/pagesComponents/administrativePanelPage/centralizedModal/JsonToCsv";
import moment from "moment";
import { orderTable } from "../../Utils/orderTable";

export function OldCompanies(){
    const history = useHistory();

    const [input,setInput] = useState('');
    const [search,setSearch] = useState('');
    const [datasTable,setDatasTable] = useState([]);
    const [businessData,setBusinessData] = useState({});
    const [loading,setLoading] = useState(true);
    const [isOpen,setIsOpen] = useState(false);

    
    const [order,setOrder] = useState(1);
    const [filterBusiness,setFilterBusiness] = useState('');


    const data = new Date();
    
    useEffect(() => {
        async function loadDatas(){
            const response = await api.get(`/getBusinessAdm/?quantity=1000&search=${search}&sync=${filterBusiness}`, {
                headers: {
                  token: localStorage.getItem('@Inoveclube:token')
                }
            })
            //console.log(response.data)
            setDatasTable(response.data.business);
            setLoading(false);
        }
        loadDatas()
    },[search,filterBusiness]);

    const totalOldsCompanies = useMemo(() => datasTable.length,[datasTable]);


    function handleInput(event){
        event.preventDefault();
        setSearch(input.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase())
    }

    function handleDownloadCSV(){
        setLoading(true);

        let newArray = datasTable.map((data) => {
            return({
                ID: data.idBusiness,
                ID_Customizado: data.idCustomized,
                Empresa: data.name,
                Cidade: data.city,
                Estado: data.state,
                Bairro: data.neighborhood,
                CNPJ: data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                Data_Inauguração: data.openingDate !== '' ? moment(data.openingDate?.slice(0, 16)).format('DD/MM/YYYY') : '', 
                Data_Sincronizacao: moment(data.lastSync?.slice(0, 16)).format('DD/MM/YYYY HH:mm')
            })
        })

        download_csv(newArray, 'Relatório das Empresas');
        setLoading(false);
    }


    const handleIsOrder = useCallback((fildName) => {
        setOrder(order => -order);

        let arr = [...datasTable];

        let newArr = orderTable(arr,fildName,order);
        
        setDatasTable(newArr)
    },[datasTable,order])


    //console.log('Atualizou: '+data)
    setInterval(() => {
        window.location.reload(true)
        clearInterval()
    },1000 * 3600);




    return(
        <Container>
            <Header
                back={() => history.push('/adm')}
                refrash={() => window.location.reload(true)}
                handleDownloadCSV={handleDownloadCSV}
            />

            {
                isOpen &&
                <Modal
                    isOpen={isOpen}
                    setIsOpen={() => setIsOpen(!isOpen)}
                    businessData={businessData}
                />
            }

            <div className="lastSync">
                <span>Última atualização da página: {moment(data).format('DD/MM/YYYY hh:mm')}h</span>
            </div>
            
            <Input
                input={input}
                setInput={(event) => setInput(event.target.value)}
                action={handleInput}
                radioButtons={[
                    {id: 1,label: 'Listar todas empresas', value: ''},
                    {id: 2,label: 'Listar somente sincronizadas', value: '1'},
                    {id: 3,label: 'Listar somente não sincronizadas', value: '2'}
                ]}
                filter={filterBusiness}
                setFilter={setFilterBusiness}
            />            

            <Table
                loading={loading}
                datasTable={datasTable}
                order={order}
                handleIsOrder={handleIsOrder}
                setIsOpen={() => setIsOpen(!isOpen)}
                setBusinessData={setBusinessData}
            />

            <strong>Listados: {totalOldsCompanies} empresas</strong>
        </Container>
    )
}